import { Component } from '@angular/core';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import packageInfo from '../../../package.json';
import { NavbarStatus } from '../models/application-models/navbar';
import { NavigationService } from '../services/navigation.service';
import { VersionModalComponent } from './version-modal/version-modal.component';

@Component({
  selector: 'app-version',
  templateUrl: './version.component.html',
  styleUrls: ['./version.component.css']
})
export class VersionComponent {
  faInfoCircle = faInfoCircle;

  NavbarStatus = NavbarStatus;

  version: string = packageInfo.version;
  year: number = new Date().getFullYear();

  constructor(
    public navigationService: NavigationService,
    private ngbModal: NgbModal
  ) { }

  openVersionModal(){
    const options: NgbModalOptions = {
      centered: true
    }
    const modalRef = this.ngbModal.open(VersionModalComponent, options);
    modalRef.componentInstance.modalRef = modalRef;
  }
}
